export const DEBUG_UNIT_GET_UNIT_DATA = "DEBUG_UNIT_GET_UNIT_DATA";
export const DEBUG_UNIT_GET_UNIT_DATA_RESPONSE = "DEBUG_UNIT_GET_UNIT_DATA_RESPONSE";